import { render, staticRenderFns } from "./transfersDetails.vue?vue&type=template&id=00a18666&scoped=true"
import script from "./transfersDetails.vue?vue&type=script&lang=js"
export * from "./transfersDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a18666",
  null
  
)

export default component.exports